<template>
    <div class="pt-2 pb-6 md:py-6">
        <header-component :title="$t('products.modify_project')"></header-component>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <div class="py-4">
            <route-tabs-component :tabs="tabs"></route-tabs-component>
          </div>

          <section class="mx-auto max-w-7xl">
            <div class="md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-6">
              <router-view class="md:col-span-3 lg:col-span-2"></router-view>
              <aside>
                <product-card-preview></product-card-preview>
                <custom-categories-component class="mt-10 hidden"></custom-categories-component>
              </aside>
            </div>
          </section>
        </div>
    </div>
</template>

<script>
    import HeaderComponent from "@/views/common/HeaderComponent";
    import RouteTabsComponent from "@/components/navigation/RouteTabsComponent";
    import ProductCardPreview from "@/views/products/ProductEdit/ProductCardPreview";
    import CustomCategoriesComponent from "@/views/products/ProductEdit/CustomCategoriesComponent";
    import {useProductsStore} from "@/stores/products";

    export default {
        name: "ProductEditComponent",
        components: {CustomCategoriesComponent, ProductCardPreview, HeaderComponent, RouteTabsComponent},
        setup(){

          const productsStore = useProductsStore()

          return {
           productsStore
          }
        },
        computed: {
          tabs() {
            const params = { id: this.$route.params.id }

            return [
              {
                to: { name: 'products-edit', params },
                label: 'products.general',
                icon: { paths: ['M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'] }
              },
              {
                to: { name: 'products-edit-branding', params },
                label: 'products.branding',
                icon: { paths: ['M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01'] }
              },
              {
                to: { name: 'products-edit-page', params },
                label: 'products.product_page',
                icon: { paths: ['M4 6h16M4 12h16M4 18h7'] }
              },
              {
                to: { name: 'products-edit-sell', params },
                label: 'products.sale',
                icon: {
                  solid: true,
                  paths: [
                    'M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z',
                    'M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z'
                  ]
                }
              },
              {
                to: { name: 'products-edit-seo', params },
                label: 'products.seo_text',
                icon: { paths: ['M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z'] }
              },
              {
                to: { name: 'attach-project-to-product', params },
                label: 'products.projects',
                icon: { paths: ['M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z'] }
              },
            ]
          }
        },
        mounted() {
          this.productsStore.getProduct(this.$route.params.id)
        }
    }
</script>
